import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { STATIC_TOP_PAGES_LINK } from '../static-content';
class Header extends Component {
  moveToBuild() {
    this.props.history.push('/build/workout');
  }

  render() {
    const isAuthenticated = this.props.user && this.props.user.isAuthenticated
    const { pathname } = this.props.location;
    return (
      <header id="home">
        <nav className="navbar navbar-default active-border navbar-fixed navbar-transparent white bootsnav">
          <div className="container">
            <div className="navbar-header">
              <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#navbar-menu">
                <i className="fa fa-bars"></i>
              </button>
              <Link className="navbar-brand" to={'/'} >
                <img src="/assets/img/logo.png" className="logo logo-display" alt="Logo" />
                <img src="/assets/img/logo.png" className="logo logo-scrolled" alt="Logo" />
              </Link>
            </div>
            <div className="collapse navbar-collapse" id="navbar-menu">
              {!pathname.includes('/follow') && !pathname.includes('/brand') &&
                <ul className="nav navbar-nav navbar-right" data-in="#" data-out="#">
                  {
                    STATIC_TOP_PAGES_LINK.map((link, i) => (
                      <li key={i}>
                        <Link className="smooth-menu" to={link.route} >
                          {link.text}
                        </Link>
                      </li>
                    ))
                  }

                  {
                    isAuthenticated ?
                      <Fragment>
                        <li></li>
                        <li>
                          <a onClick={() => this.moveToBuild()}>Build</a>
                        </li>
                      </Fragment>
                      : <Fragment>
                        <li>
                          <a data-toggle="modal" data-target="#login">Log in</a>
                        </li>
                        <li>
                          <a style={{width:'140px'}} data-toggle="modal" data-target="#freedownload">Try it free</a>
                        </li>
                      </Fragment>
                  }
                </ul>
              }
            </div>
          </div>
        </nav>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js